var EHDI = EHDI || Object.create(null);

EHDI.components = EHDI.components || Object.create(null);

EHDI.components.ShapeManager = function() { 
    var _shape = [];
    
    var _this = this;
    var _shapeValues = _this.chooseShape();
    var _width = _shapeValues.width;
    var _height = _shapeValues.height;
    var _selectedBox = null;
    var _count = 0;
    var _types = ["bluebox", "coloredbox"];
    var _curType = _types[Math.floor(EHDI.NumberUtil.randomRange(0, _types.length))];
    
    var _boxContainer = new EHDI.aka.Container();
    
    EHDI.aka.Container.call(this);
    this.addChild(_boxContainer);
    _boxContainer.position.set(EHDI.screen.stageWidth * 0.5, EHDI.screen.stageHeight * 0.75);
    
    var processSelection = function(box) {
        //process if outside
        //shake if inside
        
        var indexX = box.indexX;
        var indexZ = box.indexZ;
        
        if((indexX - 1 >= 0 && _shape[box.indexY][indexX - 1][indexZ] && indexX + 1 < _shape[box.indexY].length && _shape[box.indexY][indexX + 1][indexZ]) || (indexZ - 1 >= 0 && _shape[box.indexY][indexX][indexZ - 1] && indexZ + 1 < _shape[box.indexY][indexX].length && _shape[box.indexY][indexX][indexZ + 1])) {
            box.shake();
            return;
        }
        
        
        if(_selectedBox === null) {
            _selectedBox = box;
            _selectedBox.select();
        } else {
            if(_selectedBox.artifactType === box.artifactType) {
                _selectedBox.correct();
                box.correct();
                EHDI.scene.GameScene.scoreHolder.addScore(10);
                _shape[box.indexY][box.indexX][box.indexZ] = null;
                _shape[_selectedBox.indexY][_selectedBox.indexX][_selectedBox.indexZ] = null;
                _selectedBox = null;
                _count-=2;
                if(_count <= 0) {
                    _curType = _types[Math.floor(EHDI.NumberUtil.randomRange(0, _types.length))];
                    _shape = [];
                    _shapeValues = _this.chooseShape();
                    _width = _shapeValues.width;
                    _height = _shapeValues.height;
                    _boxContainer.destroy({children : true});
                    _boxContainer = new EHDI.aka.Container();
                    _this.addChild(_boxContainer)
                    createShape();
                    randomizeArtifacts();
                    repositionArtifacts();
                    sortArtifactsLayering();
                    _boxContainer.position.set(EHDI.screen.stageWidth * 0.5, EHDI.screen.stageHeight * 0.75);
                }
            } else {
                _selectedBox.incorrect();
                box.incorrect();
                _selectedBox = null;
            }
        }
    }
    
    var createShape = function() {
        for(var y = 0; y < _height; y++) {
            var yAxis = [];
            for(var x = 0; x < _width; x++) {
                var xAxis = [];
                for(var z = 0; z < _width; z++) {
                    var zAxis = null;
                    xAxis.push(zAxis);
                }
                yAxis.push(xAxis);
            } 
            _shape.push(yAxis);
        }
    }
    
    var randomizeArtifacts = function() {
        _count = _shapeValues.values.length;
        while(_shapeValues.values.length > 0) {
            var randomValue = Math.floor(EHDI.NumberUtil.randomRange(1, 7));
            var shapePosition = _shapeValues.values.splice(Math.floor(EHDI.NumberUtil.randomRange(0, _shapeValues.values.length)), 1)[0];
//            var shapePosition = _shapeValues.values.splice(0, 1)[0];
            var tempBox; 
            
            tempBox = new EHDI.components.MatchBox(_curType, randomValue, processSelection);
            _shape[shapePosition.y][shapePosition.x][shapePosition.z] = tempBox;
            _boxContainer.addChild(tempBox);
            tempBox.indexX = shapePosition.x;
            tempBox.indexY = shapePosition.y;
            tempBox.indexZ = shapePosition.z;
//            var shapePosition = _shapeValues.values.splice(0, 1)[0];
            shapePosition = _shapeValues.values.splice(Math.floor(EHDI.NumberUtil.randomRange(0, _shapeValues.values.length)), 1)[0];
            tempBox = new EHDI.components.MatchBox(_curType, randomValue, processSelection);
            tempBox.indexX = shapePosition.x;
            tempBox.indexY = shapePosition.y;
            tempBox.indexZ = shapePosition.z;
            _shape[shapePosition.y][shapePosition.x][shapePosition.z] = tempBox;
            _boxContainer.addChild(tempBox);
            
        }
        
    }
    
    var repositionArtifacts = function() {
        for(var y = 0; y < _height; y++) {
            var yAxis = [];
            for(var x = 0; x < _width; x++) {
                var xAxis = [];
                for(var z = 0; z < _width; z++) {
                    if(_shape[y][x][z]) {
                        _shape[y][x][z].position.set(-x * _shape[y][x][z].width * 0.5 + z * _shape[y][x][z].width * 0.5, -y * _shape[y][x][z].height * 0.684 + z * _shape[y][x][z].height * 0.18 + x * _shape[y][x][z].height * 0.18);
                    }
                }
            }
        }
    }
    
    var sortArtifactsLayering = function() {
        _boxContainer.children.sort(function(a,b) {
            return a.indexZ - b.indexZ || a.indexX - b.indexX || a.indexY - b.indexY;
        })
    }
    
    var rotateCW = function(arr) {
        var temp = [];
        for (var i = 0; i < arr.length; ++i) {
            var row = [];
            for (var j = 0; j < arr[i].length; ++j) {
                row.push(arr[j][arr[i].length - i - 1]);
                if(arr[j][arr[i].length - i - 1]) {
                    arr[j][arr[i].length - i - 1].indexX = i;
                    arr[j][arr[i].length - i - 1].indexZ = j;
                }
            }
            temp.push(row);
        }
        return temp;
    }
    
    var rotateCCW = function(arr) {
        var temp = [];
        for (var i = 0; i < arr.length; ++i) {
            var row = [];
            for (var j = 0; j < arr[i].length; ++j) {
                row.push(arr[arr.length - j - 1][i]);
                if(arr[arr.length - j - 1][i]) {
                    arr[arr.length - j - 1][i].indexX = i;
                    arr[arr.length - j - 1][i].indexZ = j;
                }
            }
            temp.push(row);
        }
        return temp;
    }
    
    this.rotateAllCCW = function() {
        for(var i = 0; i < _shape.length; i++) {
            _shape[i] = rotateCCW(_shape[i]);
        }
        repositionArtifacts();
        sortArtifactsLayering();
    }
    
    this.rotateAllCW = function() {
        for(var i = 0; i < _shape.length; i++) {
           _shape[i] =  rotateCW(_shape[i]);
        }
        repositionArtifacts();
        sortArtifactsLayering();
    }
    
    createShape();
    randomizeArtifacts();
    repositionArtifacts();
    sortArtifactsLayering();
}

EHDI.components.ShapeManager.prototype = Object.create(EHDI.aka.Container.prototype);


EHDI.components.ShapeManager.prototype.chooseShape = function() {
    var smallCube = {
        width : 3,
        height : 4,
        values : [
            {x : 0, y : 0, z : 0},
            {x : 0, y : 0, z : 1},
            {x : 0, y : 0, z : 2},
            {x : 1, y : 0, z : 0},
            {x : 1, y : 0, z : 1},
            {x : 1, y : 0, z : 2},
            {x : 2, y : 0, z : 0},
            {x : 2, y : 0, z : 1},
            {x : 2, y : 0, z : 2},
            {x : 0, y : 1, z : 0},
            {x : 0, y : 1, z : 1},
            {x : 0, y : 1, z : 2},
            {x : 1, y : 1, z : 0},
            {x : 1, y : 1, z : 1},
            {x : 1, y : 1, z : 2},
            {x : 2, y : 1, z : 0},
            {x : 2, y : 1, z : 1},
            {x : 2, y : 1, z : 2},
            {x : 0, y : 2, z : 0},
            {x : 0, y : 2, z : 1},
            {x : 0, y : 2, z : 2},
            {x : 1, y : 2, z : 0},
            {x : 1, y : 2, z : 1},
            {x : 1, y : 2, z : 2},
            {x : 2, y : 2, z : 0},
            {x : 2, y : 2, z : 1},
            {x : 2, y : 2, z : 2},
            {x : 0, y : 3, z : 0},
            {x : 0, y : 3, z : 2},
            {x : 1, y : 3, z : 1},
            {x : 2, y : 3, z : 0},
            {x : 2, y : 3, z : 2},
        ]
    }
    
    var largeCube = {
        width : 4,
        height : 4,
        values: [
            {x : 0, y : 0, z : 0},
            {x : 0, y : 0, z : 1},
            {x : 0, y : 0, z : 2},
            {x : 0, y : 0, z : 3},
            {x : 1, y : 0, z : 0},
            {x : 1, y : 0, z : 1},
            {x : 1, y : 0, z : 2},
            {x : 1, y : 0, z : 3},
            {x : 2, y : 0, z : 0},
            {x : 2, y : 0, z : 1},
            {x : 2, y : 0, z : 2},
            {x : 2, y : 0, z : 3},
            {x : 3, y : 0, z : 0},
            {x : 3, y : 0, z : 1},
            {x : 3, y : 0, z : 2},
            {x : 3, y : 0, z : 3},
            {x : 0, y : 1, z : 0},
            {x : 0, y : 1, z : 1},
            {x : 0, y : 1, z : 2},
            {x : 0, y : 1, z : 3},
            {x : 1, y : 1, z : 0},
            {x : 1, y : 1, z : 1},
            {x : 1, y : 1, z : 2},
            {x : 1, y : 1, z : 3},
            {x : 2, y : 1, z : 0},
            {x : 2, y : 1, z : 1},
            {x : 2, y : 1, z : 2},
            {x : 2, y : 1, z : 3},
            {x : 3, y : 1, z : 0},
            {x : 3, y : 1, z : 1},
            {x : 3, y : 1, z : 2},
            {x : 3, y : 1, z : 3},
            {x : 0, y : 2, z : 0},
            {x : 0, y : 2, z : 1},
            {x : 0, y : 2, z : 2},
            {x : 0, y : 2, z : 3},
            {x : 1, y : 2, z : 0},
            {x : 1, y : 2, z : 1},
            {x : 1, y : 2, z : 2},
            {x : 1, y : 2, z : 3},
            {x : 2, y : 2, z : 0},
            {x : 2, y : 2, z : 1},
            {x : 2, y : 2, z : 2},
            {x : 2, y : 2, z : 3},
            {x : 3, y : 2, z : 0},
            {x : 3, y : 2, z : 1},
            {x : 3, y : 2, z : 2},
            {x : 3, y : 2, z : 3},
            {x : 0, y : 3, z : 0},
            {x : 0, y : 3, z : 1},
            {x : 0, y : 3, z : 2},
            {x : 0, y : 3, z : 3},
            {x : 1, y : 3, z : 0},
            {x : 1, y : 3, z : 1},
            {x : 1, y : 3, z : 2},
            {x : 1, y : 3, z : 3},
            {x : 2, y : 3, z : 0},
            {x : 2, y : 3, z : 1},
            {x : 2, y : 3, z : 2},
            {x : 2, y : 3, z : 3},
            {x : 3, y : 3, z : 0},
            {x : 3, y : 3, z : 1},
            {x : 3, y : 3, z : 2},
            {x : 3, y : 3, z : 3},
        ]
    }
    
    var cross = {
        width : 4,
        height : 5,
        values: [
            {x : 1, y : 0, z : 1},
            {x : 1, y : 0, z : 2},
            {x : 2, y : 0, z : 1},
            {x : 2, y : 0, z : 2},
            {x : 1, y : 1, z : 1},
            {x : 1, y : 1, z : 2},
            {x : 2, y : 1, z : 1},
            {x : 2, y : 1, z : 2},
            {x : 1, y : 2, z : 0},
            {x : 1, y : 2, z : 1},
            {x : 1, y : 2, z : 2},
            {x : 1, y : 2, z : 3},
            {x : 2, y : 2, z : 0},
            {x : 2, y : 2, z : 1},
            {x : 2, y : 2, z : 2},
            {x : 2, y : 2, z : 3},
            {x : 1, y : 3, z : 0},
            {x : 1, y : 3, z : 1},
            {x : 1, y : 3, z : 2},
            {x : 1, y : 3, z : 3},
            {x : 2, y : 3, z : 0},
            {x : 2, y : 3, z : 1},
            {x : 2, y : 3, z : 2},
            {x : 2, y : 3, z : 3},
            {x : 1, y : 4, z : 1},
            {x : 1, y : 4, z : 2},
            {x : 2, y : 4, z : 1},
            {x : 2, y : 4, z : 2},
        ]
    }
    
    var pyramid = {
        width : 5,
        height : 4,
        values: [
            {x : 0, y : 0, z : 0},
            {x : 0, y : 0, z : 1},
            {x : 0, y : 0, z : 2},
            {x : 0, y : 0, z : 3},
            {x : 0, y : 0, z : 4},
            {x : 1, y : 0, z : 0},
            {x : 1, y : 0, z : 1},
            {x : 1, y : 0, z : 2},
            {x : 1, y : 0, z : 3},
            {x : 1, y : 0, z : 4},
            {x : 2, y : 0, z : 0},
            {x : 2, y : 0, z : 1},
            {x : 2, y : 0, z : 2},
            {x : 2, y : 0, z : 3},
            {x : 2, y : 0, z : 4},
            {x : 3, y : 0, z : 0},
            {x : 3, y : 0, z : 1},
            {x : 3, y : 0, z : 2},
            {x : 3, y : 0, z : 3},
            {x : 3, y : 0, z : 4},
            {x : 4, y : 0, z : 0},
            {x : 4, y : 0, z : 1},
            {x : 4, y : 0, z : 2},
            {x : 4, y : 0, z : 3},
            {x : 4, y : 0, z : 4},
            {x : 1, y : 1, z : 1},
            {x : 1, y : 1, z : 2},
            {x : 1, y : 1, z : 3},
            {x : 2, y : 1, z : 1},
            {x : 2, y : 1, z : 2},
            {x : 2, y : 1, z : 3},
            {x : 3, y : 1, z : 1},
            {x : 3, y : 1, z : 2},
            {x : 3, y : 1, z : 3},
            {x : 1, y : 2, z : 1},
            {x : 1, y : 2, z : 2},
            {x : 1, y : 2, z : 3},
            {x : 2, y : 2, z : 1},
            {x : 2, y : 2, z : 2},
            {x : 2, y : 2, z : 3},
            {x : 3, y : 2, z : 1},
            {x : 3, y : 2, z : 2},
            {x : 3, y : 2, z : 3},
            {x : 2, y : 3, z : 2},
        ]
    }
    
    var house = {
        width : 5,
        height : 5,
        values: [
            {x : 2, y : 0, z : 0},
            {x : 2, y : 0, z : 1},
            {x : 2, y : 0, z : 2},
            {x : 2, y : 0, z : 3},
            {x : 2, y : 0, z : 4},
            {x : 3, y : 0, z : 0},
            {x : 3, y : 0, z : 1},
            {x : 3, y : 0, z : 2},
            {x : 3, y : 0, z : 3},
            {x : 3, y : 0, z : 4},
            {x : 2, y : 1, z : 0},
            {x : 2, y : 1, z : 1},
            {x : 2, y : 1, z : 2},
            {x : 2, y : 1, z : 3},
            {x : 2, y : 1, z : 4},
            {x : 3, y : 1, z : 0},
            {x : 3, y : 1, z : 1},
            {x : 3, y : 1, z : 2},
            {x : 3, y : 1, z : 3},
            {x : 3, y : 1, z : 4},
            {x : 2, y : 2, z : 0},
            {x : 2, y : 2, z : 1},
            {x : 2, y : 2, z : 2},
            {x : 2, y : 2, z : 3},
            {x : 2, y : 2, z : 4},
            {x : 3, y : 2, z : 0},
            {x : 3, y : 2, z : 1},
            {x : 3, y : 2, z : 2},
            {x : 3, y : 2, z : 3},
            {x : 3, y : 2, z : 4},
            {x : 2, y : 3, z : 1},
            {x : 2, y : 3, z : 2},
            {x : 2, y : 3, z : 3},
            {x : 3, y : 3, z : 1},
            {x : 3, y : 3, z : 2},
            {x : 3, y : 3, z : 3},
            {x : 2, y : 4, z : 2},
            {x : 3, y : 4, z : 2},
        ]
    }
    
    var heart = {
        width : 5,
        height : 4,
        values: [
            {x : 2, y : 0, z : 2},
            {x : 3, y : 0, z : 2},
            {x : 4, y : 0, z : 2},
            {x : 2, y : 1, z : 1},
            {x : 2, y : 1, z : 2},
            {x : 2, y : 1, z : 3},
            {x : 3, y : 1, z : 1},
            {x : 3, y : 1, z : 2},
            {x : 3, y : 1, z : 3},
            {x : 4, y : 1, z : 1},
            {x : 4, y : 1, z : 2},
            {x : 4, y : 1, z : 3},
            {x : 2, y : 2, z : 0},
            {x : 2, y : 2, z : 1},
            {x : 2, y : 2, z : 2},
            {x : 2, y : 2, z : 3},
            {x : 2, y : 2, z : 4},
            {x : 3, y : 2, z : 0},
            {x : 3, y : 2, z : 1},
            {x : 3, y : 2, z : 2},
            {x : 3, y : 2, z : 3},
            {x : 3, y : 2, z : 4},
            {x : 4, y : 2, z : 0},
            {x : 4, y : 2, z : 1},
            {x : 4, y : 2, z : 2},
            {x : 4, y : 2, z : 3},
            {x : 4, y : 2, z : 4},
            {x : 2, y : 3, z : 0},
            {x : 2, y : 3, z : 1},
            {x : 2, y : 3, z : 3},
            {x : 2, y : 3, z : 4},
            {x : 3, y : 3, z : 0},
            {x : 3, y : 3, z : 1},
            {x : 3, y : 3, z : 2},
            {x : 3, y : 3, z : 3},
            {x : 3, y : 3, z : 4},
            {x : 4, y : 3, z : 0},
            {x : 4, y : 3, z : 1},
            {x : 4, y : 3, z : 3},
            {x : 4, y : 3, z : 4},
        ]
    }
    
    
    
    var shapeRandomizer = [smallCube, largeCube, heart, house, cross, pyramid];
//    var shapeRandomizer = [cross];
    
    return shapeRandomizer[Math.floor(EHDI.NumberUtil.randomRange(0, shapeRandomizer.length))];
    
    
}